import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHome: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconHome"><Path fillRule="evenodd" clipRule="evenodd" d="M10.4323 1.87009C11.3476 1.13331 12.6524 1.13331 13.5677 1.87009L20.0677 7.10256C20.6572 7.57712 21 8.29318 21 9.04998V18.5C21 19.8807 19.8807 21 18.5 21H5.5C4.11929 21 3 19.8807 3 18.5V9.04998C3 8.29318 3.34282 7.57712 3.93234 7.10256L10.4323 1.87009Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHome;
